import {
    useRecordContext,
    Link,
    UseRecordContextParams,
} from 'react-admin';
import { stringify } from 'query-string';
import { cloneElement, ReactElement } from 'react';

interface LinkFieldProps extends UseRecordContextParams {
    children: ReactElement;
}
const LinkField = (props: LinkFieldProps) => {

    const record = useRecordContext(props);

    return <Link
        to={{
            pathname: props.reference,
            search: stringify({
                filter: JSON.stringify({ [props.target]: record?.id }),
            }),
        }}
        onClick={e => e.stopPropagation()}
    >
        {cloneElement(props.children, props)}
    </Link >

}

export default LinkField